import React, { useEffect, useState } from 'react';
import searchFill from '@iconify/icons-eva/search-fill';
import { Icon } from '@iconify/react';
import {
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Box } from '@mui/system';
import { HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight } from 'react-icons/hi';

// table component
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { AiOutlineMinus } from 'react-icons/ai';
import { BiSearch } from 'react-icons/bi';
import { MdOutlineAdd, MdOutlineMoreHoriz } from 'react-icons/md';

// import { CloseIcon } from 'react-icons'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

import { StyledIconButton, StyledTableRow } from '../../../../utils/StyleTable';
import Loader from '../../../Loader';
import { CommonApiforJourney } from '../../JourneyApi';
import Scrollbar from '../../../../components/Scrollbar';
import useJourneySelector from '../../../../store/Slice/Journey/JourneySelector';
import useLoginSelector from '../../../../store/Slice/Login/LoginSelector';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '6px',
    height: '32px',
    fontWeight: 500,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    color: '#0d4689'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    padding: '4px 6px',
    height: '32px'
  }
}));

export default function AddJourney2({ handleNext, handlePrev }) {
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState('md');
  const [cardTypeApiData, setCardTypeApiData] = useState(
    JSON.parse(localStorage.getItem('cardTypeListAll'))
  );

  const [openLoader, setOpenLoader] = useState(false); // loader
  const [cardPurposeNameObj, setCardPurposeNameObj] = useState([]);
  const [docDataListAllResp, setDocDataListAllResp] = useState([]);
  const [wizardsStateData, setWizardsStateData] = useState({
    errorMessage: null,
    errorPopUp: false,
    companyId: null,
    journeyId: null,
    userId: null,
    docDataList: [],
    wizards: [
      {
        isReviewWizard: false,
        journeyId: null,
        reviewLayoutId: null,
        wizardCode: null,
        wizardCurrentSeq: null,
        wizardDefaultSeq: null,
        wizardDescription: null,
        wizardId: null,
        wizardIsActive: true,
        wizardIsPublish: true,
        wizardName: null,

        selectedCards: [
          {
            cardCurrentSeq: null,
            cardCurrentTitle: null,
            cardMasterId: null,
            journeyCardId: null,
            journeyCardIsActive: null,
            masterCardModel: null,
            wizardId: null,
            cardTypeList: cardTypeApiData?.cardTypeList,
            cardTypeId: null,
            searchString: null,
            cardTypeName: ' ',
            cardNameList: [],
            cardPurposeName: ' ',
            cardPurposeId: null,
            cardPurposeList: cardPurposeNameObj,
            noOfCardAllowed: null,
            isEnablesubcard: false,
            CardId: null,
            CardName: null,
            cardNamePopUp: false,
            cardContentPopUp: false,
            cardContentChipPopUp: false,
            cardContentList: [],
            selectedFields: [],
            chkAllField: false,
            cardNameListMsg: null
          }
        ]
      }
    ]
  });

  const { LoginData } = useLoginSelector();
  const { JourneyEdit } = useJourneySelector();

  useEffect(() => {
    wizardapiFire('cardPurposeName', '', '', '');
    wizardapiFire('isOcrRequiredSelectData', null, '', '');
  }, []);

  useEffect(() => {
    const data = localStorage.getItem('cardTypeListAll');
    if (data !== null) {
      const parsedData = JSON.parse(data);
      setCardTypeApiData(parsedData);
      const prevData = wizardsStateData;
      prevData.wizards[0].selectedCards[0].cardTypeList = parsedData.cardTypeList;
      setWizardsStateData(prevData);
    }
  }, []);

  useEffect(() => {
    if (JourneyEdit !== null) {
      if (JourneyEdit?.journeyModel.journeyWizards.length > 0) {
        const clonedJourney = structuredClone(JourneyEdit);

        const editJourneyObj = {
          errorMessage: null,
          errorPopUp: false,
          companyId: LoginData?.companyId,
          journeyId: clonedJourney?.journeyModel?.journeyWizards[0].journeyId,
          userId: LoginData?.userId,
          docDataList: docDataListAllResp
        };
        editJourneyObj.wizards = [];
        clonedJourney?.journeyModel?.journeyWizards.forEach((requestItem, requestItemIndex) => {
          editJourneyObj.wizards.push({
            journeyId: requestItem?.journeyId,
            isReviewWizard: requestItem?.isReviewWizard,
            reviewLayoutId: requestItem?.reviewLayoutId,
            wizardCode: requestItem?.wizardCode,
            wizardCurrentSeq:
              requestItem?.wizardCurrentSeq !== null ? Number(requestItem?.wizardCurrentSeq) : null,
            wizardDefaultSeq:
              requestItem?.wizardDefaultSeq !== null ? Number(requestItem?.wizardDefaultSeq) : null,
            wizardDescription: requestItem?.wizardDescription,
            wizardId: requestItem?.wizardId,
            wizardIsActive: requestItem?.wizardIsActive,
            wizardIsPublish: requestItem?.wizardIsPublish,
            wizardName: requestItem?.wizardName,
            selectedCards: []
          });
          requestItem?.selectedCards.forEach((carddItem, carddItemIndex) => {
            // carddItem?.masterCardModel.cardType.isEnabled = true;
            if (carddItem?.masterCardModel?.cardType) {
              carddItem.masterCardModel.cardType.isEnabled = true;
            }

            let cardNameListArray = [];
            let cardContentListArray = [];
            cardTypeApiData?.cardNameList.map((item) => {
              if (item[carddItem?.masterCardModel.cardType.typeId] !== undefined) {
                cardNameListArray = item[carddItem?.masterCardModel.cardType.typeId];
              }
              return cardNameListArray;
            });

            let documentArray = [];
            let withoutDocumentArray = [];
            const data = localStorage.getItem('cardTypeListAll');
            if (data !== null) {
              const parsedData = JSON.parse(data);
              documentArray = parsedData.cardTypeList;
              withoutDocumentArray = cardTypeApiData?.cardTypeList;
              if (carddItem?.masterCardModel.cardType.typeCode === 'DOCUMENT') {
                documentArray.forEach((cardTypeListItem) => {
                  if (cardTypeListItem.typeCode === 'DOCUMENT') {
                    cardTypeListItem.isEnabled = true;
                  } else {
                    cardTypeListItem.isEnabled = false;
                  }
                });
              }

              if (carddItem?.masterCardModel.cardType.typeCode !== 'DOCUMENT') {
                withoutDocumentArray.forEach((cardTypeListItem) => {
                  if (cardTypeListItem.typeCode !== 'DOCUMENT') {
                    cardTypeListItem.isEnabled = true;
                  } else {
                    cardTypeListItem.isEnabled = false;
                  }
                });
              }
            }

            cardTypeApiData?.cardContentList.forEach((item) => {
              if (item[carddItem?.masterCardModel.cardMasterId] !== undefined) {
                item[carddItem?.masterCardModel.cardMasterId].forEach((dataItem, cdIndex) => {
                  carddItem?.selectedFields.forEach((selectedFieldsItem) => {
                    if (dataItem.cardFieldMappId === selectedFieldsItem.cardFieldMappId) {
                      dataItem.ocrDocumentMappId = selectedFieldsItem.ocrDocumentMappId;
                      dataItem.ocrDocumentMapping =
                        selectedFieldsItem.ocrDocumentMapping !== null
                          ? JSON.stringify(selectedFieldsItem.ocrDocumentMapping)
                          : ' ';
                      dataItem.cardFieldMappId =
                        selectedFieldsItem.cardFieldMapping.cardFieldMappId;
                      dataItem.cardMasterId = selectedFieldsItem.cardFieldMapping.cardMasterId;
                      dataItem.fieldId = selectedFieldsItem.cardFieldMapping.fieldId;
                      dataItem.mappIsActive = selectedFieldsItem.cardFieldMapping.mappIsActive;
                      dataItem.fieldPreviewIsActive =
                        selectedFieldsItem.cardFieldMapping.fieldPreviewIsActive;

                      dataItem.fieldDefaultSeq =
                        selectedFieldsItem.cardFieldMapping.fieldDefaultSeq !== null &&
                        selectedFieldsItem.cardFieldMapping.fieldDefaultSeq !== '' &&
                        selectedFieldsItem.cardFieldMapping.fieldDefaultSeq !== undefined
                          ? Number(selectedFieldsItem.cardFieldMapping.fieldDefaultSeq)
                          : '';
                      dataItem.fieldDefaultIcon =
                        selectedFieldsItem.cardFieldMapping.fieldDefaultIcon;
                      dataItem.fieldDefaultIsMendatory =
                        selectedFieldsItem.cardFieldMapping.fieldDefaultIsMendatory;
                      dataItem.fieldDefaultValidationRequired =
                        selectedFieldsItem.cardFieldMapping.fieldDefaultValidationRequired;
                      dataItem.fieldDefaultIsVerificationRequired =
                        selectedFieldsItem.cardFieldMapping.fieldDefaultIsVerificationRequired;
                      dataItem.fieldDefaultIsOcrRequired =
                        selectedFieldsItem.cardFieldMapping.fieldDefaultIsOcrRequired;

                      dataItem.journeyCardDetailModel.journeyCardId =
                        selectedFieldsItem.journeyCardId;
                      dataItem.journeyCardDetailModel.cardDetailId =
                        selectedFieldsItem.cardDetailId;
                      dataItem.journeyCardDetailModel.cardFieldMappId =
                        selectedFieldsItem.cardFieldMappId;
                      dataItem.journeyCardDetailModel.storedField = selectedFieldsItem.storedField;
                      dataItem.journeyCardDetailModel.fieldCurrentSeq =
                        selectedFieldsItem.fieldCurrentSeq !== null &&
                        selectedFieldsItem.fieldCurrentSeq !== undefined &&
                        selectedFieldsItem.fieldCurrentSeq !== ''
                          ? Number(selectedFieldsItem.fieldCurrentSeq)
                          : '';
                      dataItem.journeyCardDetailModel.fieldCurrentIsMendatory =
                        selectedFieldsItem.fieldCurrentIsMendatory;
                      dataItem.journeyCardDetailModel.fieldCurrentValidationRequired =
                        selectedFieldsItem.fieldCurrentValidationRequired;
                      dataItem.journeyCardDetailModel.fieldCurrentIsOcrRequired =
                        selectedFieldsItem.fieldCurrentIsOcrRequired;
                      dataItem.journeyCardDetailModel.fieldCurrentIsVerificationRequired =
                        selectedFieldsItem.fieldCurrentIsVerificationRequired;
                      dataItem.journeyCardDetailModel.cardDetailIsActive =
                        selectedFieldsItem.cardDetailIsActive;
                    }
                  });
                });
                cardContentListArray = item[carddItem?.masterCardModel.cardMasterId];
              }
            });

            editJourneyObj.wizards[requestItemIndex].selectedCards.push({
              searchString: null,
              cardCurrentSeq: Number(carddItem?.cardCurrentSeq),
              cardCurrentTitle: carddItem?.cardCurrentTitle,
              cardMasterId: carddItem?.cardMasterId,
              journeyCardId: carddItem?.journeyCardId,
              journeyCardIsActive: carddItem?.journeyCardIsActive,
              masterCardModel: carddItem?.masterCardModel,
              wizardId: carddItem?.wizardId,

              CardId: carddItem?.masterCardModel.cardMasterId,
              CardName: carddItem?.masterCardModel.cardName,
              cardNamePopUp: false,
              cardContentPopUp: false,
              cardContentChipPopUp: false,
              cardTypeName: JSON.stringify(carddItem?.masterCardModel.cardType),
              cardTypeList:
                carddItem?.masterCardModel.cardType.typeCode === 'DOCUMENT'
                  ? documentArray
                  : withoutDocumentArray,
              cardTypeId: carddItem?.masterCardModel.cardType.typeId,
              cardNameList: cardTypeApiData !== null ? cardNameListArray : [],
              cardPurposeName:
                carddItem?.cardPurpose !== null ? JSON.stringify(carddItem?.cardPurpose) : ' ',
              cardPurposeId: carddItem?.cardPurposeId,
              cardPurposeList: cardPurposeNameObj,
              noOfCardAllowed: carddItem?.subCardLimit,
              isEnablesubcard: carddItem?.enableSubCard,
              cardContentList: cardTypeApiData !== null ? cardContentListArray : [],
              selectedFields: [],
              chkAllField:
                carddItem?.selectedFields.length === cardContentListArray.length ? true : false
            });

            carddItem?.selectedFields.forEach((cdItem, cdIndex) => {
              editJourneyObj.wizards[requestItemIndex].selectedCards[
                carddItemIndex
              ].selectedFields.push({
                journeyCardDetailModel: {
                  journeyCardId: carddItem?.journeyCardId,
                  cardDetailId: carddItem?.selectedFields[cdIndex].cardDetailId,
                  cardFieldMappId: carddItem?.selectedFields[cdIndex].cardFieldMappId,
                  storedField: carddItem?.selectedFields[cdIndex].storedField,
                  fieldCurrentSeq:
                    carddItem?.selectedFields[cdIndex].fieldCurrentSeq !== null &&
                    carddItem?.selectedFields[cdIndex].fieldCurrentSeq !== undefined &&
                    carddItem?.selectedFields[cdIndex].fieldCurrentSeq !== ''
                      ? Number(carddItem?.selectedFields[cdIndex].fieldCurrentSeq)
                      : '',
                  fieldCurrentIsMendatory:
                    carddItem?.selectedFields[cdIndex].fieldCurrentIsMendatory,
                  fieldCurrentValidationRequired:
                    carddItem?.selectedFields[cdIndex].fieldCurrentValidationRequired,
                  fieldCurrentIsOcrRequired:
                    carddItem?.selectedFields[cdIndex].fieldCurrentIsOcrRequired,
                  fieldCurrentIsVerificationRequired:
                    carddItem?.selectedFields[cdIndex].fieldCurrentIsVerificationRequired,
                  cardDetailIsActive: carddItem?.selectedFields[cdIndex].cardDetailIsActive,
                  cardFieldMapping: carddItem?.selectedFields[cdIndex].cardFieldMapping
                },
                ocrDocumentMappId: carddItem?.selectedFields[cdIndex].ocrDocumentMappId,
                ocrDocumentMapping: JSON.stringify(
                  carddItem?.selectedFields[cdIndex].ocrDocumentMapping
                ),
                fieldPreviewIsActive: false,
                cardDetailId: carddItem?.selectedFields[cdIndex].cardDetailId,
                cardDetailIsActive: carddItem?.selectedFields[cdIndex].cardDetailIsActive,
                cardFieldMappId: Number(carddItem?.selectedFields[cdIndex].cardFieldMappId),
                cardMasterId: carddItem?.cardMasterId,
                fieldId: carddItem?.selectedFields[cdIndex].cardFieldMapping.fieldId,

                fieldDefaultSeq:
                  carddItem?.selectedFields[cdIndex].cardFieldMapping.fieldDefaultSeq !== null &&
                  carddItem?.selectedFields[cdIndex].cardFieldMapping.fieldDefaultSeq !==
                    undefined &&
                  carddItem?.selectedFields[cdIndex].cardFieldMapping.fieldDefaultSeq !== ''
                    ? Number(carddItem?.selectedFields[cdIndex].cardFieldMapping.fieldDefaultSeq)
                    : '',
                fieldDefaultIcon:
                  carddItem?.selectedFields[cdIndex].cardFieldMapping.fieldDefaultIcon,
                fieldDefaultIsMendatory:
                  carddItem?.selectedFields[cdIndex].cardFieldMapping.fieldDefaultIsMendatory,
                fieldDefaultValidationRequired:
                  carddItem?.selectedFields[cdIndex].cardFieldMapping
                    .fieldDefaultValidationRequired,
                mappIsActive: carddItem?.selectedFields[cdIndex].cardFieldMapping.mappIsActive,
                fieldDefaultIsVerificationRequired:
                  carddItem?.selectedFields[cdIndex].cardFieldMapping
                    .fieldDefaultIsVerificationRequired,
                fieldDefaultIsOcrRequired:
                  carddItem?.selectedFields[cdIndex].cardFieldMapping.fieldDefaultIsOcrRequired,
                journeyCardFieldsMaster:
                  carddItem?.selectedFields[cdIndex].cardFieldMapping.journeyCardFieldsMaster
              });
            });

            editJourneyObj.wizards[requestItemIndex].selectedCards[
              carddItemIndex
            ].cardTypeList.forEach((cardTypeListItem) => {});
          });
        });
        setWizardsStateData(editJourneyObj);
      }
    }
  }, [JourneyEdit, docDataListAllResp]);

  const wizardapiFire = async (type, condition, parentIndex, childIndex) => {
    let journeyDetailsId = localStorage.getItem('journeyDetailsId');
    journeyDetailsId = JSON.parse(journeyDetailsId);

    const companyIdObj = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId
    };
    let methodName = '';
    let endapiPath = '';
    const token = LoginData?.jwt;

    if (type === 'cardPurposeName') {
      companyIdObj.empSubTypeId =
        JourneyEdit !== null
          ? JourneyEdit?.journeyModel.employmentSubTypeId
          : journeyDetailsId !== null && journeyDetailsId !== undefined
          ? journeyDetailsId.employmentSubTypeId
          : '';
      methodName = 'POST';
      endapiPath = 'journey/card-purposes';
      loanTypebycompany(
        type,
        methodName,
        endapiPath,
        JSON.stringify(companyIdObj),
        token,
        '',
        parentIndex,
        childIndex
      );
    } else if (type === 'isOcrRequiredSelectData') {
      if (journeyDetailsId !== null && journeyDetailsId !== undefined) {
        companyIdObj.employmentSubtypeId = journeyDetailsId.employmentSubTypeId;
        companyIdObj.employmentTypeId = journeyDetailsId.employmentCategoryId;
        companyIdObj.isFetchOnlyOcrEligibleDocs = true;
        companyIdObj.loanSubtypeId = journeyDetailsId.loanSubTypeId;
        companyIdObj.loanTypeId = journeyDetailsId.parentLoanId;
        methodName = 'POST';
        endapiPath = 'journey/mapped-documents';
        loanTypebycompany(
          type,
          methodName,
          endapiPath,
          JSON.stringify(companyIdObj),
          token,
          '',
          parentIndex,
          childIndex
        );
      }
    } else if (type === 'saveWizard') {
      let allowToFireApi = true;
      wizardsStateData.wizards.forEach((parentItem, parentItemIndex) => {
        if (parentItem.wizardCurrentSeq === null || parentItem.wizardCurrentSeq === '') {
          setWizardsStateData({
            ...wizardsStateData,
            errorMessage: 'Wizard Sequence could not be left empty',
            errorPopUp: true
          });
          allowToFireApi = false;
          return false;
        } else if (parentItem.wizardName === null || parentItem.wizardName === '') {
          setWizardsStateData({
            ...wizardsStateData,
            errorMessage: 'Wizard Title could not be left empty',
            errorPopUp: true
          });
          allowToFireApi = false;
          return false;
        } else if (parentItem.selectedCards.length > 0) {
          parentItem.selectedCards.forEach((selItem, selItemIndex) => {
            if (selItem.cardCurrentSeq === null || selItem.cardCurrentSeq === '') {
              setWizardsStateData({
                ...wizardsStateData,
                errorMessage: 'Card Sequence could not be left empty',
                errorPopUp: true
              });
              allowToFireApi = false;
              return false;
            } else if (selItem.cardTypeName === null || selItem.cardTypeName === '') {
              setWizardsStateData({
                ...wizardsStateData,
                errorMessage: 'Card Type could not be left empty',
                errorPopUp: true
              });
              allowToFireApi = false;
              return false;
            } else if (selItem.cardPurposeName === null || selItem.cardPurposeName === ' ') {
              setWizardsStateData({
                ...wizardsStateData,
                errorMessage: 'Card Purpose Name could not be left empty',
                errorPopUp: true
              });
              allowToFireApi = false;
              return false;
            } else if (selItem.CardName === null || selItem.CardName === '') {
              setWizardsStateData({
                ...wizardsStateData,
                errorMessage: 'Card Name could not be left empty',
                errorPopUp: true
              });
              allowToFireApi = false;
              return false;
            } else if (selItem.selectedFields.length === 0) {
              setWizardsStateData({
                ...wizardsStateData,
                errorMessage: 'Card Content could not be left empty',
                errorPopUp: true
              });
              allowToFireApi = false;
              return false;
            }
          });
        }
      });

      if (allowToFireApi === true) {
        const arrayData = wizardsStateData.wizards;
        let loanTypeValidate = true;

        const wizardDefaultSeqValidate = arrayData.map((item) => item.wizardCurrentSeq);
        const isDuplicateWizard = wizardDefaultSeqValidate.some(
          (item, idx) => wizardDefaultSeqValidate.indexOf(item) !== idx
        );

        if (isDuplicateWizard === true) {
          setWizardsStateData({
            ...wizardsStateData,
            errorMessage: 'Wizard Sequence should be Different',
            errorPopUp: true
          });
          loanTypeValidate = false;
        }

        const wizardDescriptionValidate = arrayData.map((item) => item.wizardName.trim());
        const isDuplicateWizardDescriptionValidate = wizardDescriptionValidate.some(
          (item, idx) => wizardDescriptionValidate.indexOf(item) !== idx
        );

        if (isDuplicateWizardDescriptionValidate === true) {
          setWizardsStateData({
            ...wizardsStateData,
            errorMessage: 'Wizard Title should be Different',
            errorPopUp: true
          });
          loanTypeValidate = false;
        }

        arrayData.every((item, index) => {
          const cardSeqValidate = item.selectedCards.map(
            (itemnext, indexmx) => itemnext.cardCurrentSeq
          );
          const isDuplicatecardCurrentSeqValidate = cardSeqValidate.some(
            (item, idx) => cardSeqValidate.indexOf(item) !== idx
          );

          if (isDuplicatecardCurrentSeqValidate === true) {
            setWizardsStateData({
              ...wizardsStateData,
              errorMessage: 'Card Sequence for same Wizard should be Different',
              errorPopUp: true
            });
            loanTypeValidate = false;
          }

          const cardTitleValidate = item.selectedCards.map((itemnext, indexmx) =>
            itemnext.cardCurrentTitle.trim()
          );
          const isDuplicatecardTitleSeqValidate = cardTitleValidate.some(
            (item, idx) => cardTitleValidate.indexOf(item) !== idx
          );

          if (isDuplicatecardTitleSeqValidate === true) {
            setWizardsStateData({
              ...wizardsStateData,
              errorMessage: 'Card Heading for same Wizard should be Different',
              errorPopUp: true
            });
            loanTypeValidate = false;
          }

          return loanTypeValidate;
        });
        if (loanTypeValidate === true) {
          if (journeyDetailsId !== undefined) {
            companyIdObj.journeyId = journeyDetailsId.journeyId;
            companyIdObj.wizards = [];
            wizardsStateData.wizards.forEach((requestItem, requestItemIndex) => {
              companyIdObj.wizards.push({
                journeyId: journeyDetailsId.journeyId,
                isReviewWizard: requestItem?.isReviewWizard,
                reviewLayoutId: requestItem?.reviewLayoutId,
                wizardCode: requestItem?.wizardCode,
                wizardCurrentSeq:
                  requestItem?.wizardCurrentSeq !== null
                    ? Number(requestItem?.wizardCurrentSeq)
                    : null,
                wizardDefaultSeq:
                  requestItem?.wizardDefaultSeq !== null
                    ? Number(requestItem?.wizardDefaultSeq)
                    : null,
                wizardDescription: requestItem?.wizardDescription,
                wizardId: requestItem?.wizardId,
                wizardIsActive: requestItem?.wizardIsActive,
                wizardIsPublish: requestItem?.wizardIsPublish,
                wizardName: requestItem?.wizardName,
                selectedCards: []
              });
              requestItem?.selectedCards.forEach((carddItem, carddItemIndex) => {
                companyIdObj.wizards[requestItemIndex].selectedCards.push({
                  cardCurrentSeq: Number(carddItem?.cardCurrentSeq),
                  cardCurrentTitle: carddItem?.cardCurrentTitle,
                  cardMasterId: carddItem?.masterCardModel.cardMasterId,
                  cardPurposeId: carddItem?.cardPurposeId,
                  enableSubCard: carddItem?.isEnablesubcard,
                  subCardLimit: carddItem?.noOfCardAllowed,
                  journeyCardId: carddItem?.journeyCardId,
                  journeyCardIsActive: null,
                  masterCardModel: {
                    ...carddItem?.masterCardModel,
                    companyId: LoginData?.companyId,
                    userId: LoginData?.userId
                  },
                  wizardId: carddItem?.wizardId,
                  selectedFields: []
                });
                carddItem?.selectedFields.forEach((cdItem, cdIndex) => {
                  const selectedFieldsObjexts = {
                    cardDetailId:
                      carddItem?.selectedFields[cdIndex].journeyCardDetailModel.cardDetailId,
                    cardDetailIsActive:
                      carddItem?.selectedFields[cdIndex].journeyCardDetailModel.cardDetailIsActive,
                    journeyCardId:
                      JourneyEdit !== null
                        ? JourneyEdit?.journeyModel?.journeyWizards[requestItemIndex]
                            ?.selectedCards[carddItemIndex]?.journeyCardId
                        : carddItem?.selectedFields[cdIndex].journeyCardDetailModel.journeyCardId,
                    cardFieldMappId: Number(cdItem.cardFieldMappId)
                  };

                  carddItem?.cardContentList.forEach((cardContentListItem) => {
                    if (cardContentListItem.fieldId === cdItem.fieldId) {
                      selectedFieldsObjexts.ocrDocumentMappId =
                        cardContentListItem.ocrDocumentMappId;
                      selectedFieldsObjexts.fieldCurrentIsMendatory =
                        cardContentListItem.journeyCardDetailModel.fieldCurrentIsMendatory;
                      selectedFieldsObjexts.fieldCurrentIsOcrRequired =
                        cardContentListItem.journeyCardDetailModel.fieldCurrentIsOcrRequired;
                      selectedFieldsObjexts.fieldCurrentIsVerificationRequired =
                        cardContentListItem.journeyCardDetailModel.fieldCurrentIsVerificationRequired;
                      selectedFieldsObjexts.fieldCurrentSeq =
                        cardContentListItem.journeyCardDetailModel.fieldCurrentSeq !== null &&
                        cardContentListItem.journeyCardDetailModel.fieldCurrentSeq !== undefined &&
                        cardContentListItem.journeyCardDetailModel.fieldCurrentSeq !== ''
                          ? Number(cardContentListItem.journeyCardDetailModel.fieldCurrentSeq)
                          : '';
                      selectedFieldsObjexts.fieldCurrentValidationRequired =
                        cardContentListItem.journeyCardDetailModel.fieldCurrentValidationRequired;
                    }
                  });
                  companyIdObj.wizards[requestItemIndex].selectedCards[
                    carddItemIndex
                  ].selectedFields.push(selectedFieldsObjexts);
                });
              });
            });

            methodName = 'POST';
            endapiPath = 'journey/save-design-flow-configs';
            loanTypebycompany(
              type,
              methodName,
              endapiPath,
              JSON.stringify(companyIdObj),
              token,
              '',
              parentIndex,
              childIndex
            );
          }
        }
      }
    }
  };

  const loanTypebycompany = async (
    type,
    method,
    endpoint,
    credentials,
    authToken,
    frmData,
    parentIndex,
    childIndex
  ) => {
    // setOpenLoader(true);
    const responseData = await CommonApiforJourney(
      method,
      endpoint,
      credentials,
      authToken,
      frmData
    );
    if (responseData.status === 'success') {
      // setOpenLoader(false);
      if (type === 'cardPurposeName') {
        wizardsStateData.wizards[0].selectedCards[0].cardPurposeList =
          responseData.data.cardPurposes;
        setCardPurposeNameObj(responseData.data.cardPurposes);
      } else if (type === 'isOcrRequiredSelectData') {
        setDocDataListAllResp(responseData.data.mappedDocuments);
        wizardsStateData.docDataList = responseData.data.mappedDocuments;
      } else if (type === 'saveWizard') {
        clearFormData();
        handleNext();
      }
    }
    // else if (responseData.status === 'error') {
    // }
  };

  const openCloseChipPopUp = (type, openClose, parentIndex, childIndex, rowId) => {
    let prevData = wizardsStateData;
    prevData = wizardsStateData.wizards;
    if (type === 'cardName') {
      prevData[parentIndex].selectedCards[childIndex].searchString = null;
      if (openClose === 'open') {
        prevData[parentIndex].selectedCards[childIndex].cardNamePopUp = true;
        if (prevData[parentIndex].selectedCards[childIndex].cardNameList.length === 0) {
          const Cname = JSON.parse(prevData[parentIndex]?.selectedCards[childIndex]?.cardTypeName);
          prevData[parentIndex].selectedCards[
            childIndex
          ].cardNameListMsg = `No cards list is available for card-type ${Cname.typeName}`;
        } else {
          prevData[parentIndex].selectedCards[childIndex].cardNameListMsg = null;
        }
      } else {
        prevData[parentIndex].selectedCards[childIndex].cardNamePopUp = false;
      }
    } else if (type === 'cardContent') {
      prevData[parentIndex].selectedCards[childIndex].searchString = null;
      if (openClose === 'open') {
        prevData[parentIndex].selectedCards[childIndex].cardContentPopUp = true;
        const oldAllData = prevData[parentIndex].selectedCards[childIndex].selectedFields;
        if (oldAllData.length > 0) {
          const objData = { oldData: oldAllData };
          localStorage.setItem('oldselectedFields', JSON.stringify(objData));
          oldAllData.forEach((oldAllDataItem) => {
            prevData[parentIndex].selectedCards[childIndex].cardContentList.forEach(
              (cardContentListItem) => {
                if (
                  cardContentListItem.cardFieldMappId === oldAllDataItem.cardFieldMappId &&
                  cardContentListItem.fieldId === oldAllDataItem.fieldId &&
                  cardContentListItem.journeyCardFieldsMaster.fieldCode ===
                    oldAllDataItem.journeyCardFieldsMaster.fieldCode
                ) {
                  cardContentListItem.journeyCardDetailModel.cardDetailIsActive =
                    oldAllDataItem.journeyCardDetailModel.cardDetailIsActive;
                }
              }
            );
          });
        }
        if (
          prevData[parentIndex].selectedCards[childIndex].selectedFields.length ===
          prevData[parentIndex].selectedCards[childIndex].cardContentList.length
        ) {
          prevData[parentIndex].selectedCards[childIndex].chkAllField = true;
        }
      } else {
        prevData[parentIndex].selectedCards[childIndex].cardContentPopUp = false;
      }
    } else if (type === 'cardContentChip') {
      if (openClose === 'open') {
        prevData[parentIndex].selectedCards[childIndex].cardContentChipPopUp = true;
      } else {
        prevData[parentIndex].selectedCards[childIndex].cardContentChipPopUp = false;
      }
    } else if (type === 'selectedCardName') {
      if (openClose.target.checked === true) {
        const checkedVal = JSON.parse(openClose.target.value);
        prevData[parentIndex].selectedCards[childIndex].CardId = checkedVal.cardMasterId;
        prevData[parentIndex].selectedCards[childIndex].CardName = checkedVal.cardName;
        prevData[parentIndex].selectedCards[childIndex].masterCardModel = checkedVal;
        prevData[parentIndex].selectedCards[childIndex].cardContentList = [];
        prevData[parentIndex].selectedCards[childIndex].selectedFields = [];
        prevData[parentIndex].selectedCards[childIndex].chkAllField = false;

        if (JourneyEdit !== null) {
          if (JourneyEdit?.journeyModel.journeyWizards.length > 0) {
            if (
              JourneyEdit?.journeyModel?.journeyWizards[parentIndex]?.selectedCards[childIndex]
                ?.cardMasterId !== checkedVal.cardMasterId
            ) {
              prevData[parentIndex].selectedCards[childIndex].cardCurrentTitle = '';
            } else {
              prevData[parentIndex].selectedCards[childIndex].cardCurrentTitle =
                JourneyEdit?.journeyModel?.journeyWizards[parentIndex]?.selectedCards[
                  childIndex
                ]?.cardCurrentTitle;
            }
          }
        }

        cardTypeApiData?.cardContentList.forEach((item) => {
          if (item[checkedVal.cardMasterId] !== undefined) {
            prevData[parentIndex].selectedCards[childIndex].cardContentList =
              item[checkedVal.cardMasterId];
          }
        });
      }
    } else if (type === 'enablesubcard') {
      if (openClose.target.checked === true) {
        prevData[parentIndex].selectedCards[childIndex].isEnablesubcard = true;
      } else {
        prevData[parentIndex].selectedCards[childIndex].isEnablesubcard = false;
        prevData[parentIndex].selectedCards[childIndex].noOfCardAllowed = null;
      }
    } else if (type === 'cardContentChipList') {
      const allData = prevData[parentIndex].selectedCards[childIndex].cardContentList;
      if (prevData[parentIndex].selectedCards[childIndex].chkAllField === true) {
        prevData[parentIndex].selectedCards[childIndex].chkAllField = false;
        allData.forEach((cdItem) => {
          cdItem.journeyCardDetailModel.cardDetailIsActive = false;
        });
        prevData[parentIndex].selectedCards[childIndex].selectedFields = [];
      } else {
        prevData[parentIndex].selectedCards[childIndex].chkAllField = true;
        prevData[parentIndex].selectedCards[childIndex].selectedFields =
          prevData[parentIndex].selectedCards[childIndex].cardContentList;
        if (JourneyEdit !== null) {
          allData.forEach((cdItem) => {
            cdItem.journeyCardDetailModel.cardDetailIsActive = true;
            JourneyEdit?.journeyModel?.journeyWizards[parentIndex]?.selectedCards[
              childIndex
            ]?.selectedFields.forEach((selectedFieldsItem) => {
              if (
                selectedFieldsItem.cardFieldMapping.journeyCardFieldsMaster.fieldName ===
                cdItem.journeyCardFieldsMaster.fieldName
              ) {
                cdItem.journeyCardDetailModel.cardDetailId = selectedFieldsItem.cardDetailId;
                cdItem.journeyCardDetailModel.cardFieldMappId = selectedFieldsItem.cardFieldMappId;

                cdItem.journeyCardDetailModel.cardFieldMapping =
                  selectedFieldsItem.cardFieldMapping;
                cdItem.journeyCardDetailModel.fieldCurrentIsMendatory =
                  selectedFieldsItem.fieldCurrentIsMendatory;
                cdItem.journeyCardDetailModel.fieldCurrentIsOcrRequired =
                  selectedFieldsItem.fieldCurrentIsOcrRequired;
                cdItem.journeyCardDetailModel.fieldCurrentIsVerificationRequired =
                  selectedFieldsItem.fieldCurrentIsVerificationRequired;
                cdItem.journeyCardDetailModel.fieldCurrentSeq =
                  selectedFieldsItem.fieldCurrentSeq !== null &&
                  selectedFieldsItem.fieldCurrentSeq !== undefined &&
                  selectedFieldsItem.fieldCurrentSeq !== ''
                    ? Number(selectedFieldsItem.fieldCurrentSeq)
                    : '';
                cdItem.journeyCardDetailModel.fieldCurrentValidationRequired =
                  selectedFieldsItem.fieldCurrentValidationRequired;
                cdItem.journeyCardDetailModel.journeyCardId = selectedFieldsItem.journeyCardId;
                cdItem.journeyCardDetailModel.storedField = selectedFieldsItem.storedField;
              }
            });
          });
        } else {
          allData.forEach((cdItem) => {
            cdItem.journeyCardDetailModel.cardDetailIsActive = true;
          });
        }
      }
    } else if (type === 'journeyCardDetailModel') {
      if (
        prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
          .journeyCardDetailModel.cardDetailIsActive === true
      ) {
        if (
          prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
            .journeyCardFieldsMaster.fieldCode === 'COUNTRY' ||
          prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
            .journeyCardFieldsMaster.fieldCode === 'STATE' ||
          prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
            .journeyCardFieldsMaster.fieldCode === 'CITY' ||
          prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
            .journeyCardFieldsMaster.fieldCode === 'ENTITY_COUNTRY' ||
          prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
            .journeyCardFieldsMaster.fieldCode === 'ENTITY_STATE' ||
          prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
            .journeyCardFieldsMaster.fieldCode === 'ENTITY_CITY'
        ) {
          prevData[parentIndex].selectedCards[childIndex].cardContentList.forEach(
            (cardContentListIteml) => {
              if (
                cardContentListIteml.journeyCardFieldsMaster.fieldCode === 'COUNTRY' ||
                cardContentListIteml.journeyCardFieldsMaster.fieldCode === 'STATE' ||
                cardContentListIteml.journeyCardFieldsMaster.fieldCode === 'CITY' ||
                cardContentListIteml.journeyCardFieldsMaster.fieldCode === 'ENTITY_COUNTRY' ||
                cardContentListIteml.journeyCardFieldsMaster.fieldCode === 'ENTITY_STATE' ||
                cardContentListIteml.journeyCardFieldsMaster.fieldCode === 'ENTITY_CITY'
              ) {
                cardContentListIteml.journeyCardDetailModel.cardDetailIsActive = false;
              }
            }
          );
        } else {
          prevData[parentIndex].selectedCards[childIndex].cardContentList[
            rowId
          ].journeyCardDetailModel.cardDetailIsActive = false;
        }

        const finalArray = prevData[parentIndex].selectedCards[childIndex].cardContentList.filter(
          (filterItem) => filterItem.journeyCardDetailModel.cardDetailIsActive === true
        );

        prevData[parentIndex].selectedCards[childIndex].selectedFields = finalArray;
        prevData[parentIndex].selectedCards[childIndex].chkAllField = false;
      } else {
        if (
          prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
            .journeyCardFieldsMaster.fieldCode === 'COUNTRY' ||
          prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
            .journeyCardFieldsMaster.fieldCode === 'STATE' ||
          prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
            .journeyCardFieldsMaster.fieldCode === 'CITY' ||
          prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
            .journeyCardFieldsMaster.fieldCode === 'ENTITY_COUNTRY' ||
          prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
            .journeyCardFieldsMaster.fieldCode === 'ENTITY_STATE' ||
          prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
            .journeyCardFieldsMaster.fieldCode === 'ENTITY_CITY'
        ) {
          prevData[parentIndex].selectedCards[childIndex].cardContentList.forEach(
            (cardContentListIteml) => {
              if (
                cardContentListIteml.journeyCardFieldsMaster.fieldCode === 'COUNTRY' ||
                cardContentListIteml.journeyCardFieldsMaster.fieldCode === 'STATE' ||
                cardContentListIteml.journeyCardFieldsMaster.fieldCode === 'CITY' ||
                cardContentListIteml.journeyCardFieldsMaster.fieldCode === 'ENTITY_COUNTRY' ||
                cardContentListIteml.journeyCardFieldsMaster.fieldCode === 'ENTITY_STATE' ||
                cardContentListIteml.journeyCardFieldsMaster.fieldCode === 'ENTITY_CITY'
              ) {
                cardContentListIteml.journeyCardDetailModel.cardDetailIsActive = true;
              }
            }
          );
        } else {
          prevData[parentIndex].selectedCards[childIndex].cardContentList[
            rowId
          ].journeyCardDetailModel.cardDetailIsActive = true;
        }

        const finalArray = prevData[parentIndex].selectedCards[childIndex].cardContentList.filter(
          (filterItem) => filterItem.journeyCardDetailModel.cardDetailIsActive === true
        );

        prevData[parentIndex].selectedCards[childIndex].selectedFields = finalArray;

        if (
          prevData[parentIndex].selectedCards[childIndex].selectedFields.length ===
          prevData[parentIndex].selectedCards[childIndex].cardContentList.length
        ) {
          prevData[parentIndex].selectedCards[childIndex].chkAllField = true;
        }
      }
    } else if (type === 'fieldDefaultValidationRequired') {
      if (
        prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
          .journeyCardDetailModel.fieldCurrentValidationRequired === true
      ) {
        prevData[parentIndex].selectedCards[childIndex].cardContentList[
          rowId
        ].journeyCardDetailModel.fieldCurrentValidationRequired = false;
      } else {
        prevData[parentIndex].selectedCards[childIndex].cardContentList[
          rowId
        ].journeyCardDetailModel.fieldCurrentValidationRequired = true;
      }
    } else if (type === 'fieldDefaultIsMendatory') {
      if (
        prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
          .journeyCardDetailModel.fieldCurrentIsMendatory === true
      ) {
        prevData[parentIndex].selectedCards[childIndex].cardContentList[
          rowId
        ].journeyCardDetailModel.fieldCurrentIsMendatory = false;
      } else {
        prevData[parentIndex].selectedCards[childIndex].cardContentList[
          rowId
        ].journeyCardDetailModel.fieldCurrentIsMendatory = true;
      }
    } else if (type === 'ocrRequired') {
      if (
        prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
          .journeyCardDetailModel.fieldCurrentIsOcrRequired === true
      ) {
        prevData[parentIndex].selectedCards[childIndex].cardContentList[
          rowId
        ].journeyCardDetailModel.fieldCurrentIsOcrRequired = false;
        prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId].ocrDocumentMapping =
          ' ';
        prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId].ocrDocumentMappId =
          null;
      } else {
        prevData[parentIndex].selectedCards[childIndex].cardContentList[
          rowId
        ].journeyCardDetailModel.fieldCurrentIsOcrRequired = true;
      }
    } else if (type === 'verificationRequired') {
      if (
        prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId]
          .journeyCardDetailModel.fieldCurrentIsVerificationRequired === true
      ) {
        prevData[parentIndex].selectedCards[childIndex].cardContentList[
          rowId
        ].journeyCardDetailModel.fieldCurrentIsVerificationRequired = false;
      } else {
        prevData[parentIndex].selectedCards[childIndex].cardContentList[
          rowId
        ].journeyCardDetailModel.fieldCurrentIsVerificationRequired = true;
      }
    }

    setWizardsStateData({
      ...wizardsStateData,
      wizards: prevData
    });
  };

  const handleChangeWizard = (event, parentIndex, childIndex, type, rowId) => {
    let prevData = wizardsStateData;
    prevData = wizardsStateData.wizards;
    const onlyNumber = /^\d+$/;
    if (type === 'wizardSequence') {
      const eventBVal = event.target.value;
      if (onlyNumber.test(eventBVal)) {
        prevData[parentIndex].wizardCurrentSeq = Number(event.target.value);
      } else {
        prevData[parentIndex].wizardCurrentSeq = '';
      }
    } else if (type === 'wizardTitle') {
      prevData[parentIndex].wizardName = event.target.value;
    } else if (type === 'cardSequence') {
      const eventBVal = event.target.value;
      if (onlyNumber.test(eventBVal)) {
        prevData[parentIndex].selectedCards[childIndex].cardCurrentSeq = Number(event.target.value);
      } else {
        prevData[parentIndex].selectedCards[childIndex].cardCurrentSeq = '';
      }
    } else if (type === 'cardHeading') {
      prevData[parentIndex].selectedCards[childIndex].cardCurrentTitle = event.target.value;
    } else if (type === 'cardTypeName') {
      const inputVal = JSON.parse(event.target.value);
      prevData[parentIndex].selectedCards[childIndex].CardId = '';
      prevData[parentIndex].selectedCards[childIndex].CardName = '';
      prevData[parentIndex].selectedCards[childIndex].masterCardModel = null;
      prevData[parentIndex].selectedCards[childIndex].cardTypeId = inputVal.typeId;
      prevData[parentIndex].selectedCards[childIndex].cardTypeName = event.target.value;
      prevData[parentIndex].selectedCards[childIndex].cardContentList = [];
      prevData[parentIndex].selectedCards[childIndex].selectedFields = [];
      prevData[parentIndex].selectedCards[childIndex].chkAllField = false;
      if (prevData[parentIndex].selectedCards.length > 1) {
        checkCardTypeValidation(parentIndex, inputVal.typeCode);
      }
      cardTypeApiData?.cardNameList.forEach((item) => {
        if (item[inputVal.typeId] !== undefined) {
          prevData[parentIndex].selectedCards[childIndex].cardNameList = item[inputVal.typeId];
        }
      });
    } else if (type === 'cardPurposeName') {
      const inputVal = JSON.parse(event.target.value);
      prevData[parentIndex].selectedCards[childIndex].cardPurposeId = inputVal.cardPurposeId;
      prevData[parentIndex].selectedCards[childIndex].cardPurposeName = event.target.value;
    } else if (type === 'isOcrRequiredSelectData') {
      const inputVal = JSON.parse(event.target.value);
      prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId].ocrDocumentMappId =
        inputVal.mappId;
      prevData[parentIndex].selectedCards[childIndex].cardContentList[rowId].ocrDocumentMapping =
        event.target.value;
    } else if (type === 'noOfCardAllowed') {
      const eventBVal = event.target.value;
      if (onlyNumber.test(eventBVal)) {
        prevData[parentIndex].selectedCards[childIndex].noOfCardAllowed = Number(
          event.target.value
        );
      } else {
        prevData[parentIndex].selectedCards[childIndex].noOfCardAllowed = '';
      }
    } else if (type === 'fieldDefaultSeq') {
      prevData[parentIndex].selectedCards[childIndex].cardContentList[
        rowId
      ].journeyCardDetailModel.fieldCurrentSeq = Number(event.target.value);
    } else if (type === 'searchString') {
      prevData[parentIndex].selectedCards[childIndex].searchString = event.target.value;
    }

    setWizardsStateData({
      ...wizardsStateData,
      wizards: prevData
    });
  };

  const checkCardTypeValidation = (parentIndex, typeCode) => {
    const prevData = wizardsStateData.wizards;
    prevData[parentIndex]?.selectedCards?.some((selectedCardsItem, childIndex) => {
      if (typeCode === 'DOCUMENT') {
        selectedCardsItem?.cardTypeList.forEach((cardTypeListItem) => {
          if (cardTypeListItem.typeCode === 'DOCUMENT') {
            cardTypeListItem.isEnabled = true;
          } else {
            cardTypeListItem.isEnabled = false;
          }
        });
      } else {
        selectedCardsItem?.cardTypeList.forEach((cardTypeListItem) => {
          if (cardTypeListItem.typeCode !== 'DOCUMENT') {
            cardTypeListItem.isEnabled = true;
          } else {
            cardTypeListItem.isEnabled = false;
          }
        });
      }
      return selectedCardsItem;
    });
    setWizardsStateData({
      ...wizardsStateData,
      wizards: prevData
    });
  };

  const addWizard = (parentIndex, type) => {
    const cardTypeListData = localStorage.getItem('cardTypeListAll');
    let prevData = wizardsStateData;
    prevData = wizardsStateData.wizards;
    if (type === 'addWizardList') {
      prevData.push({
        isReviewWizard: false,
        journeyId: null,
        reviewLayoutId: null,
        wizardCode: null,
        wizardCurrentSeq: null,
        wizardDefaultSeq: null,
        wizardDescription: null,
        wizardId: null,
        wizardIsActive: true,
        wizardIsPublish: true,
        wizardName: null,

        selectedCards: [
          {
            cardCurrentSeq: null,
            cardCurrentTitle: null,
            cardMasterId: null,
            journeyCardId: null,
            journeyCardIsActive: null,
            masterCardModel: null,
            wizardId: null,
            cardTypeList:
              cardTypeListData !== null ? JSON.parse(cardTypeListData).cardTypeList : [],
            cardTypeId: null,
            cardTypeName: ' ',
            searchString: null,
            cardNameList: [],
            cardPurposeName: ' ',
            cardPurposeId: null,
            cardPurposeList: cardPurposeNameObj,
            noOfCardAllowed: null,
            isEnablesubcard: false,
            CardId: null,
            CardName: null,
            cardNamePopUp: false,
            cardContentPopUp: false,
            cardContentChipPopUp: false,
            cardContentList: [],
            selectedFields: [],
            chkAllField: false,
            cardNameListMsg: null
          }
        ]
      });
    } else if (type === 'cardList') {
      prevData[parentIndex].selectedCards.push({
        cardCurrentSeq: null,
        cardCurrentTitle: null,
        cardMasterId: null,
        journeyCardId: null,
        journeyCardIsActive: null,
        masterCardModel: null,
        wizardId: null,
        cardTypeList: cardTypeApiData?.cardTypeList,
        cardTypeId: null,
        searchString: null,
        cardTypeName: ' ',
        cardNameList: [],
        cardPurposeName: ' ',
        cardPurposeId: null,
        cardPurposeList: cardPurposeNameObj,
        noOfCardAllowed: null,
        isEnablesubcard: false,
        CardId: null,
        CardName: null,
        cardNamePopUp: false,
        cardContentPopUp: false,
        cardContentChipPopUp: false,
        cardContentList: [],
        selectedFields: [],
        chkAllField: false,
        cardNameListMsg: null
      });
      if (prevData[parentIndex].selectedCards.length > 1) {
        const cardTName = JSON.parse(prevData[parentIndex].selectedCards[0].cardTypeName);
        checkCardTypeValidation(parentIndex, cardTName.typeCode);
        prevData[parentIndex].selectedCards[
          prevData[parentIndex].selectedCards.length - 1
        ].cardTypeList = prevData[parentIndex].selectedCards[0].cardTypeList;
      } else {
        prevData[parentIndex].selectedCards[0].cardTypeList.forEach((selectedCardsItem) => {
          selectedCardsItem.isEnabled = true;
        });
      }
    }

    setWizardsStateData({
      ...wizardsStateData,
      wizards: prevData
    });
  };

  const removeWizard = (parentIndex, childIndex, type) => {
    let prevData = wizardsStateData;
    prevData = wizardsStateData.wizards;
    if (type === 'removeWizard') {
      prevData.splice(parentIndex, 1);
    } else if (type === 'cardList') {
      prevData[parentIndex].selectedCards.splice(childIndex, 1);
      if (prevData[parentIndex].selectedCards.length === 1) {
        prevData[parentIndex].selectedCards[0].cardTypeList.forEach((selectedCardsItem) => {
          selectedCardsItem.isEnabled = true;
        });
      }
    }
    setWizardsStateData({
      ...wizardsStateData,
      wizards: prevData
    });
  };

  const clearFormData = () => {
    setWizardsStateData({
      errorMessage: null,
      errorPopUp: false,
      companyId: null,
      journeyId: null,
      userId: null,
      docDataList: [],
      wizards: [
        {
          isReviewWizard: false,
          journeyId: null,
          reviewLayoutId: null,
          wizardCode: null,
          wizardCurrentSeq: null,
          wizardDefaultSeq: null,
          wizardDescription: null,
          wizardId: null,
          wizardIsActive: true,
          wizardIsPublish: true,
          wizardName: null,

          selectedCards: [
            {
              cardCurrentSeq: null,
              cardCurrentTitle: null,
              cardMasterId: null,
              journeyCardId: null,
              journeyCardIsActive: null,
              masterCardModel: null,
              wizardId: null,
              searchString: null,
              cardTypeList: [],
              cardTypeId: null,
              cardTypeName: ' ',
              cardNameList: [],
              CardId: null,
              CardName: null,
              cardNamePopUp: false,
              cardContentPopUp: false,
              cardContentChipPopUp: false,
              cardContentList: [],
              selectedFields: [],
              chkAllField: false
            }
          ]
        }
      ]
    });
  };

  const closePopUp = () => {
    setWizardsStateData({
      ...wizardsStateData,
      errorMessage: null,
      errorPopUp: false
    });
  };

  return (
    <>
      {wizardsStateData.wizards &&
        wizardsStateData.wizards.map((wizardItem, wizardIndex) => (
          <Box key={`wizardList_${wizardIndex}`} className="viewLeadCard mb-3">
            <Box className="innerBoxBg" mb={3}>
              <Grid container spacing={3} alignItems="end">
                {wizardIndex > 0 ? (
                  <Grid
                    item
                    xs="auto"
                    style={{
                      position: 'absolute',
                      top: '-17px',
                      right: '20px',
                      zIndex: '99',
                      padding: '0px'
                    }}
                  >
                    <Tooltip title="Remove" placement="top" arrow>
                      <IconButton
                        onClick={() => removeWizard(wizardIndex, '', 'removeWizard')}
                        className="squareIconButtonRemove"
                      >
                        <AiOutlineMinus size={18} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                ) : (
                  ''
                )}
                <Grid item xs={4}>
                  <Box className="">
                    <Typography variant="h6" className="formLabel">
                      Wizard Sequence
                    </Typography>
                    <TextField
                      fullWidth
                      inputProps={{
                        className: 'textInput'
                      }}
                      value={wizardItem.wizardCurrentSeq}
                      onChange={(event) =>
                        handleChangeWizard(event, wizardIndex, '', 'wizardSequence', '')
                      }
                      placeholder="Type Wizard Sequence"
                    />
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Box className="">
                    <Typography variant="h6" className="formLabel">
                      Wizard Title
                    </Typography>
                    <TextField
                      fullWidth
                      inputProps={{
                        className: 'textInput'
                      }}
                      value={wizardItem.wizardName}
                      onChange={(event) =>
                        handleChangeWizard(event, wizardIndex, '', 'wizardTitle', '')
                      }
                      placeholder="Type Wizard Title"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Grid container spacing={2} alignItems="end">
              <Grid item xs>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Card Sequence
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Card Type
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Card Purpose
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Card Name
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Card Content
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            {wizardItem.selectedCards.map((selectedCardsItem, selectedCardsItemIndex) => (
              <Grid container spacing={2} mb={2} alignItems="end">
                <Grid item xs>
                  <Box className="">
                    <TextField
                      fullWidth
                      inputProps={{
                        className: 'textInput'
                      }}
                      value={selectedCardsItem.cardCurrentSeq}
                      onChange={(event) =>
                        handleChangeWizard(
                          event,
                          wizardIndex,
                          selectedCardsItemIndex,
                          'cardSequence',
                          ''
                        )
                      }
                      placeholder="Type Card Sequence"
                    />
                  </Box>
                </Grid>

                <Grid item xs>
                  <Box className="">
                    <Select
                      fullWidth
                      inputProps={{
                        className: `textInput customSelectBox dissabledMenu${selectedCardsItem.cardTypeName}`
                      }}
                      value={selectedCardsItem.cardTypeName}
                      onChange={(event) =>
                        handleChangeWizard(
                          event,
                          wizardIndex,
                          selectedCardsItemIndex,
                          'cardTypeName',
                          ''
                        )
                      }
                    >
                      <MenuItem value=" " disabled>
                        Select Card Type
                      </MenuItem>

                      {selectedCardsItem?.cardTypeList?.map(
                        (cardTypeListItem, cardTypeListIndex) => (
                          <MenuItem
                            disabled={!cardTypeListItem.isEnabled}
                            key={`cardTypeListItem_${selectedCardsItemIndex}_${cardTypeListIndex}`}
                            value={JSON.stringify(cardTypeListItem)}
                          >
                            {cardTypeListItem.typeName}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </Box>
                </Grid>

                <Grid item xs>
                  <Box className="">
                    <Select
                      fullWidth
                      inputProps={{
                        className: `textInput customSelectBox dissabledMenu${selectedCardsItem.cardPurposeName}`
                      }}
                      value={selectedCardsItem.cardPurposeName}
                      onChange={(event) =>
                        handleChangeWizard(
                          event,
                          wizardIndex,
                          selectedCardsItemIndex,
                          'cardPurposeName',
                          ''
                        )
                      }
                    >
                      <MenuItem value=" " disabled>
                        Select Card Purpose
                      </MenuItem>

                      {selectedCardsItem?.cardPurposeList?.map(
                        (cardPurposeListItem, cardPurposeListItemIndex) => (
                          <MenuItem
                            key={`cardPurposeListItem_${selectedCardsItemIndex}_${cardPurposeListItemIndex}`}
                            value={JSON.stringify(cardPurposeListItem)}
                          >
                            {cardPurposeListItem.cardPurposeName}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </Box>
                </Grid>

                <Grid item xs>
                  <Box className="">
                    <Box sx={{ position: 'relative' }}>
                      <TextField
                        fullWidth
                        inputProps={{
                          className: 'textInput'
                        }}
                        value={
                          selectedCardsItem.cardCurrentTitle !== null &&
                          selectedCardsItem.cardCurrentTitle !== undefined &&
                          selectedCardsItem.cardCurrentTitle !== ''
                            ? selectedCardsItem.cardCurrentTitle
                            : selectedCardsItem.CardName
                        }
                        placeholder="Type Card Name"
                        defaultValue={selectedCardsItem.CardName}
                      />
                      <Tooltip title="Edit" placement="top" arrow>
                        <StyledIconButton
                          className="actionButton searchIconB"
                          onClick={() =>
                            openCloseChipPopUp(
                              'cardName',
                              'open',
                              wizardIndex,
                              selectedCardsItemIndex,
                              ''
                            )
                          }
                        >
                          <BiSearch size={18} />
                        </StyledIconButton>
                      </Tooltip>
                    </Box>
                  </Box>

                  <Dialog fullWidth className="PopupBox" open={selectedCardsItem.cardNamePopUp}>
                    <DialogTitle className="popupTitle">
                      <Typography variant="h6">Select Card Name</Typography>
                      <IconButton
                        onClick={() =>
                          openCloseChipPopUp(
                            'cardName',
                            'close',
                            wizardIndex,
                            selectedCardsItemIndex,
                            ''
                          )
                        }
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                      <Box mb={2}>
                        {selectedCardsItem.cardNameListMsg === null ? (
                          <TextField
                            fullWidth
                            placeholder="Search"
                            inputProps={{
                              className: 'textInput textInputTable'
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Box
                                    component={Icon}
                                    icon={searchFill}
                                    sx={{ color: 'text.disabled' }}
                                  />
                                </InputAdornment>
                              )
                            }}
                            onChange={(event) =>
                              handleChangeWizard(
                                event,
                                wizardIndex,
                                selectedCardsItemIndex,
                                'searchString',
                                ''
                              )
                            }
                          />
                        ) : (
                          selectedCardsItem.cardNameListMsg
                        )}
                      </Box>
                      {selectedCardsItem.cardNameListMsg === null ? (
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                        >
                          {selectedCardsItem.cardNameList.map(
                            (cardNameListItem, cardNameListItemIndex) => (
                              <FormControlLabel
                                className={
                                  selectedCardsItem.searchString !== null
                                    ? !cardNameListItem.cardName
                                        .toLowerCase()
                                        .includes(selectedCardsItem.searchString.toLowerCase())
                                      ? 'hideElementItem'
                                      : ''
                                    : ''
                                }
                                key={`cardNameListItem_${selectedCardsItemIndex}_${cardNameListItemIndex}`}
                                control={
                                  <Radio
                                    checked={
                                      selectedCardsItem?.CardName === cardNameListItem?.cardName
                                    }
                                    value={JSON.stringify(cardNameListItem)}
                                    name="cardname"
                                    onClick={(event) =>
                                      openCloseChipPopUp(
                                        'selectedCardName',
                                        event,
                                        wizardIndex,
                                        selectedCardsItemIndex,
                                        ''
                                      )
                                    }
                                  />
                                }
                                label={cardNameListItem?.cardName}
                              />
                            )
                          )}
                          {selectedCardsItem?.CardName ? (
                            <TextField
                              fullWidth
                              inputProps={{
                                className: 'textInput'
                              }}
                              value={selectedCardsItem.cardCurrentTitle}
                              onChange={(event) =>
                                handleChangeWizard(
                                  event,
                                  wizardIndex,
                                  selectedCardsItemIndex,
                                  'cardHeading',
                                  ''
                                )
                              }
                              placeholder="Write Your Heading"
                            />
                          ) : (
                            ''
                          )}

                          {selectedCardsItem.cardTypeId !== 88 ? (
                            <FormGroup style={{ width: '100%' }}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={selectedCardsItem?.isEnablesubcard}
                                    name="enablesubcard"
                                    onClick={(event) =>
                                      openCloseChipPopUp(
                                        'enablesubcard',
                                        event,
                                        wizardIndex,
                                        selectedCardsItemIndex,
                                        ''
                                      )
                                    }
                                  />
                                }
                                label="Enable Sub Card"
                              />
                              {selectedCardsItem?.isEnablesubcard ? (
                                <TextField
                                  fullWidth
                                  inputProps={{
                                    className: 'textInput'
                                  }}
                                  value={selectedCardsItem.noOfCardAllowed}
                                  onChange={(event) =>
                                    handleChangeWizard(
                                      event,
                                      wizardIndex,
                                      selectedCardsItemIndex,
                                      'noOfCardAllowed',
                                      ''
                                    )
                                  }
                                  placeholder="No Of Card Allowed"
                                />
                              ) : (
                                ''
                              )}
                            </FormGroup>
                          ) : (
                            ''
                          )}
                        </RadioGroup>
                      ) : (
                        ''
                      )}
                    </DialogContent>
                    <DialogActions>
                      <Button
                        disabled={
                          selectedCardsItem.cardNameList.length > 0
                            ? selectedCardsItem.cardCurrentTitle === null ||
                              selectedCardsItem.cardCurrentTitle === ''
                            : false
                        }
                        onClick={() =>
                          openCloseChipPopUp(
                            'cardName',
                            'close',
                            wizardIndex,
                            selectedCardsItemIndex,
                            ''
                          )
                        }
                        variant="contained"
                        className="mainBtn"
                      >
                        Submit
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Grid>

                <Grid item xs>
                  <Box className="">
                    <Stack
                      direction="row"
                      spacing={1}
                      className="chipBox"
                      style={{ minHeight: '35px' }}
                    >
                      {selectedCardsItem.selectedFields
                        .slice(0, 1)
                        .map((selectedFieldsIten, selectedFieldsItenIndex) => (
                          <Chip
                            key={`selectedFieldsIten_${selectedCardsItemIndex}_${selectedFieldsItenIndex}`}
                            label={selectedFieldsIten?.journeyCardFieldsMaster?.fieldName}
                            size="small"
                          />
                        ))}
                      <IconButton
                        sx={{ padding: '0' }}
                        size="small"
                        variant="subtitle2"
                        onClick={() =>
                          openCloseChipPopUp(
                            'cardContentChip',
                            'open',
                            wizardIndex,
                            selectedCardsItemIndex,
                            ''
                          )
                        }
                      >
                        <MdOutlineMoreHoriz size={16} />
                      </IconButton>
                      <Tooltip title="Edit" placement="top" arrow>
                        <StyledIconButton
                          className="actionButton searchIconB"
                          onClick={() =>
                            openCloseChipPopUp(
                              'cardContent',
                              'open',
                              wizardIndex,
                              selectedCardsItemIndex,
                              ''
                            )
                          }
                        >
                          <BiSearch size={18} />
                        </StyledIconButton>
                      </Tooltip>
                    </Stack>
                  </Box>
                  <Dialog
                    fullWidth={fullWidth}
                    maxWidth={maxWidth}
                    className="PopupBox"
                    open={selectedCardsItem?.cardContentPopUp}
                  >
                    <DialogTitle className="popupTitle">
                      <Typography variant="h6">Select Card Content</Typography>
                      <IconButton
                        onClick={() => {
                          const prevData = wizardsStateData.wizards;
                          prevData[wizardIndex].selectedCards[selectedCardsItemIndex].searchString =
                            null;
                          prevData[wizardIndex].selectedCards[
                            selectedCardsItemIndex
                          ].cardContentPopUp = false;
                          let oldselectedFields = localStorage.getItem('oldselectedFields');
                          oldselectedFields = JSON.parse(oldselectedFields);
                          if (oldselectedFields !== null) {
                            prevData[wizardIndex].selectedCards[
                              selectedCardsItemIndex
                            ].selectedFields = oldselectedFields.oldData;
                          }
                          setWizardsStateData({ ...wizardsStateData, wizards: prevData });
                          localStorage.removeItem('oldselectedFields');
                        }}
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                      <Box mb={2}>
                        <TextField
                          fullWidth
                          placeholder="Search"
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Box
                                  component={Icon}
                                  icon={searchFill}
                                  sx={{ color: 'text.disabled' }}
                                />
                              </InputAdornment>
                            )
                          }}
                          onChange={(event) =>
                            handleChangeWizard(
                              event,
                              wizardIndex,
                              selectedCardsItemIndex,
                              'searchString',
                              ''
                            )
                          }
                        />
                      </Box>
                      <Box className="outerTableBox">
                        <Scrollbar>
                          <TableContainer
                            sx={{ height: '250px', overflow: 'auto', background: '' }}
                          >
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell padding="checkbox">
                                    <Checkbox
                                      onClick={(event) =>
                                        openCloseChipPopUp(
                                          'cardContentChipList',
                                          event,
                                          wizardIndex,
                                          selectedCardsItemIndex,
                                          ''
                                        )
                                      }
                                      size="small"
                                      sx={{ padding: '0' }}
                                      checked={selectedCardsItem?.chkAllField}
                                      name="chkAllField"
                                    />
                                  </StyledTableCell>
                                  <StyledTableCell align="">
                                    {selectedCardsItem?.masterCardModel?.cardType?.typeCode ===
                                    'DOCUMENT'
                                      ? 'Document Name'
                                      : 'Field Name'}
                                  </StyledTableCell>

                                  {selectedCardsItem?.masterCardModel?.cardType?.typeCode !==
                                  'DOCUMENT' ? (
                                    <StyledTableCell align="">Field Type</StyledTableCell>
                                  ) : (
                                    ''
                                  )}

                                  <StyledTableCell align="">
                                    {selectedCardsItem?.masterCardModel?.cardType?.typeCode ===
                                    'DOCUMENT'
                                      ? 'Field Sequence'
                                      : 'Field Sequence'}
                                  </StyledTableCell>
                                  <StyledTableCell align="">OCR Required</StyledTableCell>
                                  {selectedCardsItem?.masterCardModel?.cardType?.typeCode !==
                                  'DOCUMENT' ? (
                                    <StyledTableCell align="">Select Document</StyledTableCell>
                                  ) : (
                                    ''
                                  )}
                                  <StyledTableCell align="">
                                    {selectedCardsItem?.masterCardModel?.cardType?.typeCode ===
                                    'DOCUMENT'
                                      ? 'Verification Required'
                                      : 'Validation Required'}
                                  </StyledTableCell>
                                  <StyledTableCell align="">Optional</StyledTableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedCardsItem?.cardContentList.map(
                                  (cardContentListItem, cardContentListItemIndex) => (
                                    <StyledTableRow
                                      className={
                                        selectedCardsItem?.searchString !== null
                                          ? !cardContentListItem?.journeyCardFieldsMaster?.fieldName
                                              .toLowerCase()
                                              .includes(
                                                selectedCardsItem?.searchString.toLowerCase()
                                              )
                                            ? 'hideElementItem'
                                            : ''
                                          : ''
                                      }
                                      key={`cardContentListItem_${selectedCardsItemIndex}_${cardContentListItemIndex}`}
                                    >
                                      <StyledTableCell padding="checkbox">
                                        <Checkbox
                                          size="small"
                                          sx={{ padding: '0' }}
                                          checked={
                                            cardContentListItem?.journeyCardDetailModel
                                              ?.cardDetailIsActive
                                          }
                                          onClick={(event) =>
                                            openCloseChipPopUp(
                                              'journeyCardDetailModel',
                                              event,
                                              wizardIndex,
                                              selectedCardsItemIndex,
                                              cardContentListItemIndex
                                            )
                                          }
                                        />
                                      </StyledTableCell>
                                      <StyledTableCell align="">
                                        {cardContentListItem?.journeyCardFieldsMaster?.fieldName}
                                      </StyledTableCell>

                                      {selectedCardsItem?.masterCardModel?.cardType?.typeCode !==
                                      'DOCUMENT' ? (
                                        <StyledTableCell align="">
                                          {
                                            cardContentListItem?.journeyCardFieldsMaster?.fieldType
                                              ?.typeName
                                          }
                                        </StyledTableCell>
                                      ) : (
                                        ''
                                      )}

                                      <StyledTableCell align="">
                                        <CustomInput
                                          inputValue={
                                            cardContentListItem?.journeyCardDetailModel
                                              ?.fieldCurrentSeq !== null
                                              ? cardContentListItem?.journeyCardDetailModel
                                                  ?.fieldCurrentSeq
                                              : cardContentListItem?.fieldDefaultSeq
                                          }
                                          onChnageFunc={handleChangeWizard}
                                          wizardIndex={wizardIndex}
                                          selectedCardsItemIndex={selectedCardsItemIndex}
                                          fieldDefaultSeq="fieldDefaultSeq"
                                          cardContentListItemIndex={cardContentListItemIndex}
                                        />
                                      </StyledTableCell>
                                      <StyledTableCell align="">
                                        <Checkbox
                                          size="small"
                                          sx={{ padding: '0' }}
                                          checked={
                                            cardContentListItem?.journeyCardDetailModel
                                              ?.fieldCurrentIsOcrRequired !== null
                                              ? cardContentListItem?.journeyCardDetailModel
                                                  ?.fieldCurrentIsOcrRequired
                                              : cardContentListItem?.fieldDefaultIsOcrRequired
                                          }
                                          onClick={(event) =>
                                            openCloseChipPopUp(
                                              'ocrRequired',
                                              event,
                                              wizardIndex,
                                              selectedCardsItemIndex,
                                              cardContentListItemIndex
                                            )
                                          }
                                        />
                                      </StyledTableCell>
                                      {selectedCardsItem?.masterCardModel?.cardType?.typeCode !==
                                      'DOCUMENT' ? (
                                        <StyledTableCell align="">
                                          <Select
                                            disabled={
                                              !cardContentListItem?.journeyCardDetailModel
                                                ?.fieldCurrentIsOcrRequired
                                            }
                                            fullWidth
                                            inputProps={{
                                              className: `textInput customSelectBox dissabledMenu${cardContentListItem.ocrDocumentMapping}`
                                            }}
                                            value={cardContentListItem.ocrDocumentMapping}
                                            onChange={(event) =>
                                              handleChangeWizard(
                                                event,
                                                wizardIndex,
                                                selectedCardsItemIndex,
                                                'isOcrRequiredSelectData',
                                                cardContentListItemIndex
                                              )
                                            }
                                          >
                                            <MenuItem value=" " disabled>
                                              Select Document
                                            </MenuItem>

                                            {wizardsStateData.docDataList.map(
                                              (
                                                isOcrRequiredSelectDataItem,
                                                isOcrRequiredSelectDataItemIndex
                                              ) => (
                                                <MenuItem
                                                  key={`isOcrRequiredSelectDataItem_${cardContentListItemIndex}_${isOcrRequiredSelectDataItemIndex}`}
                                                  value={JSON.stringify(
                                                    isOcrRequiredSelectDataItem
                                                  )}
                                                >
                                                  {
                                                    isOcrRequiredSelectDataItem
                                                      .journeyDocumentMasterEntity.documentName
                                                  }
                                                </MenuItem>
                                              )
                                            )}
                                          </Select>
                                        </StyledTableCell>
                                      ) : (
                                        ''
                                      )}
                                      <StyledTableCell padding="checkbox">
                                        {selectedCardsItem?.masterCardModel?.cardType?.typeCode ===
                                        'DOCUMENT' ? (
                                          <Checkbox
                                            size="small"
                                            sx={{ padding: '0' }}
                                            checked={
                                              cardContentListItem?.journeyCardDetailModel
                                                ?.fieldCurrentIsVerificationRequired !== null
                                                ? cardContentListItem?.journeyCardDetailModel
                                                    ?.fieldCurrentIsVerificationRequired
                                                : cardContentListItem?.fieldDefaultIsVerificationRequired
                                            }
                                            onClick={(event) =>
                                              openCloseChipPopUp(
                                                'verificationRequired',
                                                event,
                                                wizardIndex,
                                                selectedCardsItemIndex,
                                                cardContentListItemIndex
                                              )
                                            }
                                          />
                                        ) : (
                                          <Checkbox
                                            checked={
                                              cardContentListItem?.journeyCardDetailModel
                                                ?.fieldCurrentValidationRequired !== null
                                                ? cardContentListItem?.journeyCardDetailModel
                                                    ?.fieldCurrentValidationRequired
                                                : cardContentListItem?.fieldDefaultValidationRequired
                                            }
                                            size="small"
                                            sx={{ padding: '0' }}
                                            onClick={(event) =>
                                              openCloseChipPopUp(
                                                'fieldDefaultValidationRequired',
                                                event,
                                                wizardIndex,
                                                selectedCardsItemIndex,
                                                cardContentListItemIndex
                                              )
                                            }
                                          />
                                        )}
                                      </StyledTableCell>
                                      <StyledTableCell padding="checkbox">
                                        <Checkbox
                                          checked={
                                            cardContentListItem?.journeyCardDetailModel
                                              ?.fieldCurrentIsMendatory !== null
                                              ? !cardContentListItem?.journeyCardDetailModel
                                                  ?.fieldCurrentIsMendatory
                                              : !cardContentListItem?.fieldDefaultIsMendatory
                                          }
                                          size="small"
                                          sx={{ padding: '0' }}
                                          onClick={(event) =>
                                            openCloseChipPopUp(
                                              'fieldDefaultIsMendatory',
                                              event,
                                              wizardIndex,
                                              selectedCardsItemIndex,
                                              cardContentListItemIndex
                                            )
                                          }
                                        />
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                      </Box>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={() =>
                          openCloseChipPopUp(
                            'cardContent',
                            'close',
                            wizardIndex,
                            selectedCardsItemIndex,
                            ''
                          )
                        }
                        variant="contained"
                        className="mainBtn"
                      >
                        Submit
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    className="PopupBox"
                    open={selectedCardsItem.cardContentChipPopUp}
                    fullWidth
                  >
                    <DialogTitle className="popupTitle">
                      <Typography variant="h6">Card Content List</Typography>
                      <IconButton
                        onClick={() =>
                          openCloseChipPopUp(
                            'cardContentChip',
                            'close',
                            wizardIndex,
                            selectedCardsItemIndex,
                            ''
                          )
                        }
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                      <Stack direction="row" sx={{ flexWrap: 'wrap' }} spacing={1}>
                        {selectedCardsItem.selectedFields.map(
                          (selectedFieldsIten, selectedFieldsItenIndex) => (
                            <Chip
                              style={{ margin: '0px 10px 10px 0' }}
                              key={`selectedFieldsIten_${selectedCardsItemIndex}_${selectedFieldsItenIndex}`}
                              label={selectedFieldsIten?.journeyCardFieldsMaster?.fieldName}
                              size="small"
                            />
                          )
                        )}
                      </Stack>
                    </DialogContent>
                  </Dialog>
                </Grid>

                {selectedCardsItemIndex > 0 ? (
                  <Grid item xs="auto">
                    <Tooltip title="Remove" placement="top" arrow>
                      <IconButton
                        onClick={() =>
                          removeWizard(wizardIndex, selectedCardsItemIndex, 'cardList')
                        }
                        className="squareIconButton"
                        sx={{ marginBottom: '4px' }}
                      >
                        <AiOutlineMinus size={18} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                ) : (
                  <Grid item xs="auto">
                    <Tooltip title="Add" placement="top" arrow>
                      <IconButton
                        onClick={() => addWizard(wizardIndex, 'cardList')}
                        className="squareIconButton"
                        sx={{ marginBottom: '4px' }}
                      >
                        <MdOutlineAdd size={18} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )}
              </Grid>
            ))}
          </Box>
        ))}

      <Box sx={{ display: 'flex', paddingTop: '1.5rem' }}>
        <Button
          onClick={() => {
            handlePrev();
          }}
          startIcon={<HiOutlineArrowNarrowLeft />}
          className="mainBtn previousBtn"
        >
          Back
        </Button>
        <Button
          className="mainBtn nextBtn"
          onClick={() => addWizard('', 'addWizardList')}
          variant="contained"
        >
          Add Wizard
        </Button>
        <Button
          onClick={() => {
            wizardapiFire('saveWizard', '', '', '');
          }}
          className="mainBtn ml-2"
          endIcon={<HiOutlineArrowNarrowRight />}
          variant="contained"
        >
          Next
        </Button>
      </Box>

      <Loader openLoader={openLoader} />
      <Dialog
        open={wizardsStateData.errorPopUp}
        onClose={closePopUp}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {wizardsStateData.errorMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closePopUp}>Retry</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

function CustomInput({
  inputValue,
  onChnageFunc,
  wizardIndex,
  selectedCardsItemIndex,
  fieldDefaultSeq,
  cardContentListItemIndex
}) {
  const [value, setVal] = useState('');
  useEffect(() => {
    setVal(inputValue);
  }, [inputValue]);

  return (
    <TextField
      placeholder=""
      inputProps={{ className: 'textInput' }}
      size="small"
      sx={{ width: '60px' }}
      value={value}
      onChange={(event) => {
        const eventBVal = event.target.value;
        const reg = /^\d+$/;
        if (reg.test(eventBVal)) {
          setVal(eventBVal);
        } else {
          setVal('');
        }
      }}
      onBlur={(e) =>
        onChnageFunc(
          e,
          wizardIndex,
          selectedCardsItemIndex,
          fieldDefaultSeq,
          cardContentListItemIndex
        )
      }
    />
  );
}
